
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { FormHeading } from "./FormHeading";
import { UseFormReturn } from "react-hook-form";

interface InventoryFieldsProps {
  form: UseFormReturn<any>;
  watchHasInventory: boolean;
}

export const InventoryFields: React.FC<InventoryFieldsProps> = ({
  form,
  watchHasInventory,
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="has_inventory"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between p-3 border rounded-md">
            <div>
              <FormHeading label="Track Inventory" />
            </div>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {watchHasInventory && (
        <FormField
          control={form.control}
          name="inventory_count"
          render={({ field }) => (
            <FormItem>
              <FormHeading label="Inventory Quantity" />
              <FormControl>
                <Input {...field} type="number" min="0" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};
